import * as React from 'react';
import cn from 'classnames';

import { useTheme } from '../../../../../theme';
import { Header as BaseHeader } from '../../../../../BaseComponents';

interface Props {
	className?: string;
	title: string;
	breadcrumbs?: React.ReactNode;
	isLoading?: boolean;
	onClose: () => void;
	onGoBackward?: () => void;
}

const ExchangeRefundHeader: React.FC<Props> = ({ className, title, breadcrumbs, isLoading, onClose, onGoBackward }) => {
	const { ExchangeRefundHeader: theme } = useTheme('Entities').Order;

	return (
		<BaseHeader
			className={cn(theme.root, className, {
				[theme.loading]: isLoading
			})}
			classes={{
				inner: theme.wrapper,
				leftSlot: theme.title,
				closeWrapper: theme.close,
				centerSlot: theme.breadcrumbs
			}}
			left={title}
			center={breadcrumbs}
			equalSlotsBasis={false}
			showEmptySlots={false}
			onClose={onClose}
			onGoBackward={onGoBackward}
		/>
	);
};

export default ExchangeRefundHeader;
